import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { db } from '../../firebase';
import moment from 'moment'


export default class CastAgreements extends Component {
  constructor (props) {
    super(props);

    this.state = {
      cast: {},
      urls: [],
      errors: {}
    };
  }

  componentWillMount () {
    var cast_id = this.props.match.params.cast_id
    console.log(cast_id)

    var scope = this
    db.ref('casts/' + cast_id).on('value', snapshot => {
      var cast = snapshot.val()
      //console.log(casts)
      scope.setState({ cast: cast })
    });

    db.ref('lp/users').on('value', snapshot => {
      var users = snapshot.val()
      db.ref('pre_reservations').on('value', snapshot => {
        var reservations = snapshot.val()

        var urls = []
        var date = ""

        moment.locale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
        for (let n in reservations) {
          for (let m in reservations[n]) {
            for (let o in reservations[n][m].casts) {
              for (let p in reservations[n][m].casts[o]) {
                if (cast_id === reservations[n][m].casts[o][p]) {
                  for (let q in reservations[n][m].dates) {
                    if ("" !== date) {
                      date += "、"
                    }
                    date += moment(parseInt(reservations[n][m].dates[q], 10)).format('YYYY年MM月DD日(dddd)HH:mm')
                  }
                  urls.push({"link": "/cast_agreement/" + cast_id + "/" + n + "/" + m, "title": users[n].family_name + "様の依頼 " + date})
                  date = ""
                }
              }
            }
          }
        }
        scope.setState({ urls })
      });
    });
  }

  render () {

    const urls = this.state.urls.map((url, i) => {
      return <Link to={url.link}><li>{url.title}</li></Link>
    })

    return (
    <div className="sp home">
      <h2>承認</h2>
      <div className="content-wrapper">
        <div className="contents">

          <p>あなたに依頼が届きました。</p>
          <br />

          <p className="bold">依頼一覧</p>
          <ul>
            {urls}
          </ul>
          <br />
        </div>
      </div>
    </div>
    );
  }
}